import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient instance for React Query.
 *
 * Default options:
 * - staleTime: 2 minutes – data is considered fresh for 2 min after fetch,
 *   so navigating back to a page shows cached data instantly.
 * - gcTime: 60 seconds – unused cache entries are garbage-collected 60s
 *   after their last observer unmounts.  Large clinics were seeing tabs
 *   hold 1 GB+ of retained memory because calendar/patient/historical
 *   query payloads stayed resident for 5 minutes after navigating away.
 *   A shorter gcTime frees that memory when a user leaves a heavy page
 *   (dashboard → tasks, patient chart → schedule, etc.).  Users who
 *   navigate back within the 60 s window still get an instant cache
 *   hit; users who return later get a fresh fetch (the data is usually
 *   live anyway).
 * - retry: 1 – retry failed requests once (apiClient already retries 429/5xx).
 * - refetchOnWindowFocus: false – avoid surprising refetches when the user
 *   tabs back; pages that need live data can override per-query.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      gcTime: 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
